import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useRef } from 'react';
import { observer } from 'mobx-react-lite';
import classNames from 'classnames';
import moment from 'moment-timezone';
import { WithLoaderWrapper } from 'ziphy-web-shared/basic/lib/loaders';
import { $calendar } from '../../Calendar.store';
import TableColumn from '../tableColumn/TableColumn';
import TimeGrid from '../timeGrid/TimeGrid';
import styles from './TableContent.module.scss';
const TableContent = ({ isLoading }) => {
    const ref = useRef(null);
    const prevHeight = useRef();
    useEffect(() => {
        if (!ref.current || isLoading)
            return;
        prevHeight.current = ref.current.clientHeight;
        if (window.scrollY === 0 && $calendar.loadCount <= 1) {
            const timeline = document.querySelector('#schedule-timeline');
            if (timeline)
                window.scrollTo({ top: timeline.offsetTop });
        }
    }, [isLoading]);
    return (_jsxs(WithLoaderWrapper, Object.assign({ isLoading: isLoading, loader: 'empty', className: classNames(styles.tableContent, styles.padding) }, { children: [_jsx(TimeGrid, { className: styles.padding }), _jsx("div", Object.assign({ ref: ref, className: classNames(styles.inner, $calendar.isAsDay && styles.isDay), style: { height: isLoading && prevHeight.current } }, { children: Object.keys($calendar.schedule)
                    .filter((date) => ($calendar.isDay && moment(date).isSame($calendar.selectedDay, 'day')) ||
                    $calendar.isWeek)
                    .map((date) => (_jsx(TableColumn, { date: date, data: $calendar.schedule[date] }, date))) }))] })));
};
export default observer(TableContent);
